/* eslint-disable jsx-a11y/img-redundant-alt */
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Barcode from "react-barcode";
import logo from "../../../../../logo.svg";
import { signInUser } from "../../../../Utility/Auth";
import { resolvePhotoUrl } from "../../../../Utility/resolvePhotoUrl";
import { useWarehouseQuery } from "../../../../../services/warehouseApi";

const GrnHeader = ({ grn, format, title }) => {
  const auth = signInUser();
  const { storeSettings } = auth;
  // console.log(grn);
  return (
    <>
      <div className="row  pb-3 mb-1 border-bottom">
        <div className="col-7">
          <img
            src={resolvePhotoUrl(
              storeSettings?.storePhoto || storeSettings?.photo,
              logo
            )}
            onError={(e) => {
              e.target.src = logo;
            }}
            height="40"
            alt="not Image"
          />
        </div>

        <div className="col-5">
          <p className="p-0 m-0 text-end">
            <b>Hotline: </b> {storeSettings?.phone || "01700000000"}
          </p>
          <p className="p-0 m-0 text-end">
            <small>{grn?.warehouse?.name}</small>
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-6 print-header-text">
          <p>
            <b>To</b>
            <br />
            {grn?.supplier?.company} <br />
            {grn?.supplier?.email} <br />
            {grn?.supplier?.phone} <br />
            {grn?.supplier?.address} <br />
          </p>

          <p>
            <b>Form</b> <br />
            {storeSettings?.storeName || "No-Name"} <br />
            {storeSettings?.email || "No-Email"}
            <br />
            {storeSettings?.phone || "01700000000"}
            <br />
            {storeSettings?.address?.street || "No-Street"} ,
            {storeSettings?.address?.city || "No-City"},{" "}
            {storeSettings?.address?.state || "No-State"},{" "}
            {storeSettings?.address?.post || "No-PostalCode"} <br />
          </p>
        </div>
        <div className="col-6 text-end">
          {!grn?.print ? <h4>[ORIGINAL]</h4> : <h4>[DUPLICATE]</h4>}

          <h4>{title}</h4>
          <span className="ps-6 d-block">
            <p>
              <b>Rtv No:</b> {grn?.rtvNo}
              <br />
              <b>RTV Date:</b>{" "}
              {grn?.createdAt && format(new Date(grn?.createdAt), "yyyy-MM-dd")}{" "}
              <br />
              <b>RTV Time:</b>{" "}
              {grn?.createdAt && format(new Date(grn?.createdAt), "h:m:s aaa")}
              <br />
            </p>
            <p className="text-end bar-code ">
              <Barcode value={grn?._id} height="40" width="1" fontSize="10" />
            </p>
          </span>
        </div>
      </div>
    </>
  );
};

export default GrnHeader;
